import React from 'react'
import { CheckboxGroup, Checkmark } from '@chakra-ui/react'
import { Checkbox } from '@/components/ui/checkbox'

// **Never put a group of these inside a FormControl.** FormControl renders a
// Field.Root, and Ark hands every checkbox in a field the *field's* control id
// as its hidden input's id (`ids.hiddenInput = field.ids.control`), which wins
// over the per-checkbox one. Every root <label> then points at the same input,
// so whichever box renders first takes every click and the rest look dead.
// Passing explicit ids does not help — the field's id wins regardless.
//
// For a group, use a heading and a CheckboxGroup holding the value:
//
//   <Box>
//     <Heading as='h3' size='sm'>Send via</Heading>
//     <CheckboxGroup value={sendVia} onValueChange={setSendVia} name='via'>
//       {VIA.map(v => <Checkbox key={v.name} value={v.name}>{v.label}</Checkbox>)}
//     </CheckboxGroup>
//   </Box>
//
// A single checkbox inside a FormControl is fine: there is nothing to collide
// with. (Fixed once in the message wizard, 30192107, then again in the API key
// dialog.)

export default ({ id, value, size, disabled, checked, isChecked, onChange, onCheckedChange, children }) => {
  return (
    <Checkbox
      id={id}
      size={size}
      disabled={disabled}
      checked={checked ?? isChecked}
      onCheckedChange={onChange || onCheckedChange}
      value={value}
    >
      {children}
    </Checkbox>
  )
}

export { CheckboxGroup, Checkmark }
